import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    LinearProgress,
    TextField,
} from "@mui/material";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { Global_CTX } from "../../contexts/global-ctx";
import { Admin_Service } from "../../services/admin/admin-service";
import { Organization_Service } from "../../services/organization/organization-service";
import { notConnectedMessage } from "../constants";
const initialFeedback = {
    hidden: true,
    message: "",
    severity: "success",
    loading: false,
};

const initial_admin: any = {
    name: "",
    organization: "",
    username: "",
};

const EditAdmin = ({ row, open, setOpen }: any) => {
    console.log(row);
    const { set_refetch_counter } = useContext(Global_CTX);
    const [feedback, setFeedback] = useState(initialFeedback);
    const [admin, set_admin] = useState(initial_admin);
    const [organization, setOrganization] = useState<any>();
    const [selectedOrg, setSelectedOrg] = useState<any>();

    const getOrganization = async () => {
        const [data, err] = await Organization_Service.getInstance().get_orgs(
            {}
        );

        if (data?.rows.length) setOrganization(data.rows);
    };

    const handle_change = (ev: ChangeEvent<HTMLInputElement>) => {
        const value = ev.target.value;
        set_admin({
            ...admin,
            [ev.target.name]: value,
        });
    };
    useEffect(() => {
        if (!row) return;
        set_admin({
            name: row.name,
            username: row.username,
            organization: row.organization.id,
        });
        getOrganization();
        setSelectedOrg(row?.defaultOrganization);
    }, [row]);

    const handleSubmit = async (ev: any) => {
        ev.preventDefault();
        setFeedback({ ...initialFeedback, loading: true });

        const [data, err] = await Admin_Service.editAdmin(row.username, {
            ...admin,
            organization: selectedOrg.code,
        });

        if (data) {
            setFeedback({
                message: data.message,
                severity: "success",
                loading: false,
                hidden: false,
            });
            set_refetch_counter((n: number) => n + 1);
        } else {
            setFeedback({
                message: err || notConnectedMessage,
                severity: "error",
                loading: false,
                hidden: false,
            });
        }
    };

    return (
        <Dialog open={open} onClose={() => setOpen(!open)} fullWidth>
            <DialogTitle>Edit</DialogTitle>

            <div style={{ padding: "5px" }}>
                {feedback.loading ? <LinearProgress /> : null}
                <section hidden={feedback.hidden}>
                    <Alert severity={feedback.severity as any}>
                        {feedback.message}
                    </Alert>
                </section>
            </div>

            <Box
                display="flex"
                flexDirection="column"
                p={1}
                style={{ gap: "12px" }}
                component={"form"}
                onSubmit={handleSubmit}
            >
                <TextField
                    label="Name"
                    fullWidth
                    value={admin.name}
                    name="name"
                    onChange={handle_change}
                    sx={{ flex: 1 }}
                    required
                />

                <TextField
                    label="Username"
                    fullWidth
                    value={admin.username}
                    name="username"
                    onChange={handle_change}
                    sx={{ flex: 1 }}
                    required
                />

                <Autocomplete
                    options={organization || []}
                    getOptionLabel={(option) => option?.name ?? ""}
                    value={selectedOrg || null}
                    onChange={(event, newValue) => {
                        setSelectedOrg(newValue);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Organization"
                            variant="outlined"
                        />
                    )}
                />

                <DialogActions>
                    <Button onClick={() => setOpen(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" type="submit">
                        Edit
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default EditAdmin;
